import { apiServer } from '../settings';
import { getToken } from './token';
// import createLog from '../utils/create-log';

const addEmail = (userGuid, userAuthorization, game, guid, email, password, done) => {
    // if (!userGuid) return done('missing userGuid')
    // if (!userAuthorization) return done('missing userAuthorization')
    if (!game) return done('missing game');
    if (!guid) return done('missing guid');
    if (!email) return done('missing email');
    if (!password) return done('missing password');

    const headers = new Headers({
        Authorization: 'Bearer ' + getToken(),
        'Content-Type': 'application/json',
    });

    const options = {
        method: 'POST',
        headers,
        mode: 'cors',
        cache: 'default',
        body: JSON.stringify({ email, password }),
    };

    const url = `${apiServer}/user-add-email?game=${game}&guid=${guid}`;

    fetch(url, options)
        .then(response => {
            return response.json();
        })
        .then(response => {
            if (response.success === false) return done(response.err);
            if (response.success === true) return done();
            if (!response.success) return done('response without success true|false');
        })
        .catch(error => {
            console.error('Error:', error);
            done(error.message);
        });
};

export default addEmail;
